/**
 * Copyright (c) 2018 - Present, CauseCode Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { IAuthData, IAuthResponse } from '@vamstar/fox-api-common/esm/user/types';

import { STORAGE_KEYS } from '../constants/storage-keys';

export const getAuthData = (): IAuthData | null => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEYS.AUTH_DATA) || '');
  } catch (e) {
    return null;
  }
};

export const setUserData = (authResponse: IAuthResponse) =>
  localStorage.setItem(STORAGE_KEYS.AUTH_DATA, JSON.stringify(authResponse.originalUser));

export const clearStorage = () => window.localStorage.clear();

/**
 * Clears auth data if unauthorized
 * */
export const clearAuthData = () => {
  localStorage.removeItem(STORAGE_KEYS.AUTH_DATA);
  window.location.reload();
};
